var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21H21",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10H21",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21V10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21V10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21V10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21V10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3L3 8H21L12 3Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.552a94efc2db913775d33d8d5b6aff4a.svg";
export { ForwardRef as ReactComponent };